import { useState, useEffect } from 'react';
import axios from 'axios';

const useSingleProduct = (productId: string | null) => {
  const [product, setProduct] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const apiUrl = process.env.REACT_APP_API_URL;
  const url = `${apiUrl}/api/products`;

  useEffect(() => {
    if (!productId) return;

    const fetchProduct = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await axios.get(`${url}/product/${productId}`);

        setProduct(response.data);
      } catch (err: any) {
        setError(err.response?.data?.message || 'Error fetching product');
      } finally {
        setLoading(false);
      }
    };

    fetchProduct();
  }, [productId, url]);

  return { product, loading, error };
};

export default useSingleProduct;
